import React from 'react';
import { connect } from 'react-redux';
import {
  columnDescription,
  columnNameLink,
  columnCode,
  columnUsers,
  columnTools,
  columnMultiSelect,
} from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import { presentationOptions } from '@/constants/states';
import CardsHeader from '@/components/cards/CardsHeader';
import urls, { codeUrl } from '@/constants/urls';
import paging, { onCategoryScroll, pagingHookConfig } from '@/hooks/paging';
import UserGroupsFilters from './UserGroupsFilters';
import UserGroupCards from '../components/UserGroupCards';
import UserGroupsTable from '../components/UserGroupsTable';
import UserGroupsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/UserGroupsPanelContainer';

const userGroupsColumns = [
  columnMultiSelect,
  columnNameLink,
  columnCode,
  columnDescription,
  columnUsers,
  columnTools,
];

const UserGroupsPanelFull = ({
  canCreate,
  canRead,
  category,
  currentPage,
  display,
  fetchData,
  newUserGroupCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  togglePresentation,
  total,
  usergroups,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus, pagingHookConfig([category]));
  return (
    <UserGroupsPanelContainer readErrors={readErrors} canRead={canRead}>
      {display === presentationOptions.CARDS && (
      <>
        <CardsHeader
          disabled={readStatus === states.PENDING}
          onClick={() => togglePresentation(category, presentationOptions.TABLE)}
        >
          <UserGroupsFilters category={category} className="aridhia-table-filter" />
        </CardsHeader>
        <UserGroupCards
          canCreate={canCreate}
          handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
          items={usergroups}
          onCheckBoxClick={(value) => onCheckBoxClick(category, value)}
          readErrors={readErrors}
          readStatus={readStatus}
          url={codeUrl(urls.USER_GROUP, newUserGroupCode, '#')}
        />
      </>
      )}
      {display !== presentationOptions.CARDS && (
        <UserGroupsTable
          canCreate={canCreate}
          category={category}
          columns={userGroupsColumns}
          currentPage={currentPage}
          fetchData={fetchData}
          newUserGroupCode={newUserGroupCode}
          onCheckBoxClick={(value) => onCheckBoxClick(category, value)}
          pageCount={pageCount}
          pageSize={pageSize}
          readErrors={readErrors}
          readStatus={readStatus}
          showColumns
          togglePresentation={togglePresentation}
          total={total}
          userGroups={usergroups}
        />
      )}
    </UserGroupsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupsPanelFull);
